<template>
  <div>
    <el-dialog
      :title="$t('filters.chooseDoor')"
      :visible.sync="doorDialogVisible"
      width="50%"
      center
    >
      <div style="margin: 10px 0 20px">
        <el-input
          :placeholder="$t('filters.chooseDoorName')"
          v-model="searchKey">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <el-button slot="append" @click="getDoorList">{{ $t('filters.search') }}</el-button>
        </el-input>
      </div>
      <div class="checkboxList doorList" v-loading="loading">
        <el-checkbox-group v-model="checkList">
          <el-checkbox v-for="(door, i) in doorList" :key="i" :label="door.posId">{{ door.doorName }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDoor">{{ $t('filters.pick') }}</el-button>
        <el-button type="primary" @click="doorDialogVisible = false">{{ $t('cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'pickDoor',
  props: {
    value: String,
    statisticFilter: Object,
    url: String,
    filterForm: {
      cityNo: Array,
      clusterGroup: Array,
      clusterName: Array,
      concept: Array,
      resellerNo: Array,
      subReseller: Array,
      format: Array,
      provinceNo: Array,
      regionNo: Array,
      tzGroup: Array,
      isHubDoor: Boolean,
    }
  },
  mounted () {
    this.posId = this.value + '';
    // this.getDoorList()
  },
  data: function () {
    return {
      loading: false,
      doorList: [], // 供筛选的门店列表
      searchKey: '', // 门店搜索关键字
      targetUrl: this.url || 'doors/search',
      checkList: [], // 选中的门店
      doorDialogVisible: false,
      posId: ''
    }
  },
  watch: {
    value: function(val,oldVal){
      if(typeof(val) != 'undefined'){
        this.posId = val + '';
      }
    },
    posId: function (val, oldVal) {
      this.$emit('input', val)
    },
  }, 
  methods: {
    change: function () {
      console.log('同步更新')
      this.$emit('input', this.posId)
    },
    clearSearchKey: function(){
      this.$set(this,'searchKey','')
      this.$set(this,'doorList',[])
      this.$set(this,'checkList',[])
      this.submitDoor()
    },
    openDialog: function () {
      this.doorList = [];
      this.checkList = [];
      this.searchKey = ""
      this.doorDialogVisible = true
    },
    isEmpty: function (data) {
      return !_.isNil(data)
    },
    getDoorList: async function () {
      let filterParams = this.filterForm?
        {
        'name': this.searchKey,
        'cityNo': this.filterForm.cityNo,
        'clusterGroup': this.filterForm.clusterGroup,
        'clusterName': this.filterForm.clusterName,
        'concept': this.filterForm.concept,
        'resellerNo': this.filterForm.resellerNo,
        'subReseller': this.filterForm.subReseller,
        'format': this.filterForm.format,
        'provinceNo': this.filterForm.provinceNo,
        'regionNo': this.filterForm.regionNo,
        'tzGroup': this.filterForm.tzGroup,
        'isHubDoor': this.filterForm.isHubDoor,
        'size': 1000
      }:{'name':this.searchKey}
      let submitParams = this.$tool.formatArrayToString(filterParams)
      let params = submitParams
      if(this.statisticFilter&&this.statisticFilter.id){
        params = {name: this.searchKey,...this.statisticFilter}
      }

      
      this.loading = true
      this.checkList = []
      let res = await window.instance.post(window.surveyUrl + this.targetUrl, params)
      res = res.data
      if (res.code === 200) {
        this.doorList = this.url?res.data : res.data.list
      } else {
      }
      this.loading = false
    },
    submitDoor: function () {
      this.doorDialogVisible = false
      const posidList = this.posId ? this.posId.split(',') : []
      this.posId = _.uniq(posidList.concat(this.checkList)).join(',')
      this.change()
    }
  }
}
</script>

<style scoped lang="sass">
.doorList
  height: 360px
  overflow: auto
.checkboxList
  .el-checkbox
    display: block
    margin: 14px 0
    font-weight: 300
  em
    font-style: normal
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/pickDoor.vue